import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Sun, Moon } from 'lucide-react';
import { authService } from '../../services/authService';
import { Button } from '@/components/ui/button';
import { useTheme } from '../../contexts/ThemeContext';

const Header = ({ onMenuToggle }) => {
  const isAuthenticated = authService.isAuthenticated();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 z-20 bg-background shadow-sm border-b border-border">
      <div className="flex items-center h-16 px-3 sm:px-4 lg:px-6 overflow-x-hidden">
        {isAuthenticated && onMenuToggle && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuToggle}
            className="lg:hidden -ml-1"
          >
            <Menu className="w-5 h-5" />
          </Button>
        )}
        <Link
          to={isAuthenticated ? "/dashboard" : "/"}
          className="text-base sm:text-lg lg:text-xl font-semibold text-foreground hover:text-primary flex-1 min-w-0"
        >
          <span className="truncate block">IronSource Dashboard</span>
        </Link>
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            className="flex-shrink-0"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </Button>
          {!isAuthenticated && (
            <Link to="/login" className="flex-shrink-0">
              <Button size="sm">
                Sign In
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
